import { z } from 'zod';

export const DailyProgramCtaSchema = z.object({
  label: z.string(),
  link: z.string(),
  target: z.string().optional(),
});
